import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2", "group-3"];

const groupInfo = {
  "group-1": [
    {
      label: "Subject",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "subject",
      type: "text",
      placeHolder: "",
      toValidate: true,
      // url: SERVER_URL + "/city/",
      // suggestionKeyword: "name",
      // backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "sender_email",
      },
    },
    {
      label: "Receiver Email",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "sender_email",
      type: "text",
      placeHolder: "",
      toValidate: true,
      // url: SERVER_URL + "/city/",
      // suggestionKeyword: "name",
      // backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "receiver_cc",
      },
    },
    {
      label: "Receiver CC",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "receiver_cc",
      type: "text",
      placeHolder: "",
      toValidate: true,
      // url: SERVER_URL + "/branch/",
      // suggestionKeyword: "name",
      // backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "from_location",
      },
    },
    {
      label: "From Location",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "from_location",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/city/",
      // suggestionKeyword: "name",
      // backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "to_location",
      },
    },
  ],
  "group-2": [
    {
      label: "To Location",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "to_location",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/city/",
      // suggestionKeyword: "name",
      // backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "loading",
      },
    },
    {
      label: "Loading",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "loading",
      type: "text",
      placeHolder: "",
      // backendOnClickName: "license_validity",
      // toValidate: true,
      keyboardNavigationMap: {
        Enter: "unloading",
      },
    },
    {
      label: "Unloading",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading",
      type: "text",
      placeHolder: "",
      // backendOnClickName: "license_validity",
      // toValidate: true,
      keyboardNavigationMap: {
        Enter: "send_mail",
      },
    },
  ],
};

const dataObject = {
  subject: "",
  sender_email: "",
  receiver_cc: "",
  from_location: "",
  to_location: "",
  loading: "",
  unloading: "",
};

function validate(values) {
  let errors = {};

  // function validator(value, regexp) {
  //   var regex = new RegExp(regexp);
  //   if (values.hasOwnProperty(value)) {
  //     if (!values[value].trim()) {
  //       errors[value] = "Required Field";
  //     } else if (!regex.test(values[value])) {
  //       errors[value] = "Validation Error";
  //     } else {
  //       errors[value] = "";
  //     }
  //   }
  // }
  // for (let group_name of groupNames) {
  //   for (let i = 0; i < groupInfo[group_name].length; i++) {
  //     console.log(groupInfo[group_name][i]);
  //     let field_object = groupInfo[group_name][i];
  //     if (field_object.toValidate) {
  //       validator(field_object.name, field_object.regExpValidation);
  //     }
  //   }
  // }
  return errors;
}

export { groupInfo, dataObject, validate };
